import { Link, useLocation } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { useSettings } from "../lib/settings";
import { WaIcon } from "./WhatsAppButton";

export function MobileActionBar() {
  const { settings } = useSettings();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const wa = (settings.whatsapp_number || "").replace(/\D/g, "");
  const tel = (settings.shop_phone || "").replace(/[^\d+]/g, "");
  const text = encodeURIComponent(`Hi ${settings.company_name || "Arnav Enterprises"}, I'd like to know more about your solar solutions.`);
  const item = "flex-1 flex flex-col items-center justify-center gap-1 py-2 text-[11px] font-semibold tracking-wide active:scale-95 transition-transform";
  return (
    <nav
      data-testid="mobile-action-bar"
      aria-label="Quick actions"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-xl border-t border-border shadow-[0_-8px_30px_rgba(15,23,42,0.08)] pb-[env(safe-area-inset-bottom)]"
    >
      <div className="flex items-stretch h-16">
        {tel && (
          <a href={`tel:${tel}`} data-testid="mobile-bar-call" className={`${item} text-secondary`}>
            <Phone className="w-5 h-5 text-primary" strokeWidth={2} />
            Call
          </a>
        )}
        {wa && (
          <a href={`https://wa.me/${wa}?text=${text}`} target="_blank" rel="noopener noreferrer" data-testid="mobile-bar-whatsapp" className={`${item} text-[#1a9e4b]`}>
            <WaIcon className="w-5 h-5" />
            WhatsApp
          </a>
        )}
        <Link to="/contact" data-testid="mobile-bar-quote" className={`${item} bg-primary text-white`}>
          <FileText className="w-5 h-5" strokeWidth={2} />
          Free Quote
        </Link>
      </div>
    </nav>
  );
}
